function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import { uniq } from 'lodash';
import { isEmptyValue, isPreviewableComponent } from "../../../../../components/DynamicForm";
import { assert } from "../../../../../utils/assert";
export function convertResponsesToDynamicForm(formAnswers) {
  return formAnswers.reduce(function (obj, formAnswer) {
    if (formAnswer.key !== undefined) {
      var questionKey = formAnswer.key;
      obj[questionKey] = formAnswer.value;
    }
    return obj;
  }, {});
}
export function convertDynamicFormToResponseAnswer(_ref) {
  var formDefinition = _ref.formDefinition,
    dynamicFormValues = _ref.dynamicFormValues;
  return Object.entries(dynamicFormValues).map(function (_ref2) {
    var _formDefinition$compo;
    var _ref3 = _slicedToArray(_ref2, 2),
      key = _ref3[0],
      value = _ref3[1];
    var type = (_formDefinition$compo = formDefinition.components.find(function (component) {
      return component.key === key;
    })) === null || _formDefinition$compo === void 0 ? void 0 : _formDefinition$compo.type;
    assert(type, "Could not find component type for key: ".concat(key));
    if (type === 'file') {
      assert(Array.isArray(value), "Expected value to be an array for key: ".concat(key));
      return {
        key: key,
        value: value.filter(function (fileValue) {
          return !isUploadingFile(fileValue);
        }).filter(function (fileValue) {
          return !hasErrorMessage(fileValue);
        }).map(function (fileValue) {
          return _typeof(fileValue) === 'object' && fileValue !== null && 'id' in fileValue ? fileValue.id : fileValue;
        })
      };
    }
    return {
      key: key,
      value: value
    };
  });
}
function isUploadingFile(fileValue) {
  if (_typeof(fileValue) === 'object' && fileValue !== null && 'uploading' in fileValue && fileValue.uploading) {
    return true;
  }
  return false;
}
function hasErrorMessage(fileValue) {
  if (_typeof(fileValue) === 'object' && fileValue !== null && 'errorMessage' in fileValue && fileValue.errorMessage) {
    return true;
  }
  return false;
}
export function getFormDataDecisions(_ref4) {
  var answersHistory = _ref4.answersHistory,
    adminRejectionText = _ref4.adminRejectionText;
  if (answersHistory.length > 0) {
    var answersWithDecisions = !answersHistory[0].submitted && answersHistory.length > 1 ? answersHistory[1].answers : answersHistory[0].answers;
    var transformedAnswersHistory = answersWithDecisions.reduce(function (acc, answer) {
      var decisions = answer.decisions,
        key = answer.key;
      var filteredDecisions = decisions.map(function (decision) {
        var type = decision.type,
          status = decision.status,
          reasonAdditionalNote = decision.reasonAdditionalNote;
        if (status === 'rejected') {
          // assert(reasonAdditionalNote, "Expected 'reasonAdditionalNote' to be defined");
          return type === 'per_item' ? {
            type: 'per_item',
            status: 'rejected',
            message: reasonAdditionalNote || adminRejectionText || '-',
            item: decision.item,
            value: answer.value
          } : {
            type: 'overall',
            status: 'rejected',
            message: reasonAdditionalNote || adminRejectionText || '-',
            value: answer.value
          };
        }
      }).filter(Boolean);
      if (filteredDecisions.length > 0) {
        acc[key] = filteredDecisions;
      }
      return acc;
    }, {});
    return transformedAnswersHistory;
  }
}
export function getAnswersCount(requirement) {
  var _requirement$response;
  var formAnswers = (_requirement$response = requirement.responses) === null || _requirement$response === void 0 ? void 0 : _requirement$response.answersHistory;
  var answers = Array.isArray(formAnswers) && formAnswers.length > 0 && formAnswers[0].answers;
  var nonBlankAnswers = Array.isArray(answers) ? answers.filter(function (answer) {
    return answer && !isEmptyValue(answer.value);
  }) : [];
  var nonBlankNoFileAnswers = nonBlankAnswers.filter(function (answer) {
    var req = requirement.formDefinition.components.find(function (component) {
      return component.key === answer.key;
    });
    return (req === null || req === void 0 ? void 0 : req.type) !== 'file';
  }) || [];
  var answersCount = nonBlankNoFileAnswers.length;
  return {
    answers: answers,
    answersCount: answersCount
  };
}
export function getAmount(requirement) {
  var components = requirement.formDefinition.components;

  // TODO: once TS is updated to > 5.5.1, remove this custom type guard
  // See: https://github.com/ApplyBoard/platform_monorepo_ui/pull/8106/files#diff-b2c3522beb829ba3c75653ea02f51604ab21f0ddd5d090963155d4189adc82ce
  var paymentInfoComponents = components.filter(function (item) {
    return item.type === 'paymentframe' || item.type === 'paymentprompt' || item.type === 'file';
  });
  if (!paymentInfoComponents.length) return undefined;
  var uniqueCurrencies = uniq(paymentInfoComponents.map(function (component) {
    var _component$properties;
    return (_component$properties = component.properties) === null || _component$properties === void 0 ? void 0 : _component$properties.currency;
  }).filter(Boolean));
  if (uniqueCurrencies.length !== 1) return undefined;
  var uniqueAmounts = uniq(paymentInfoComponents.map(function (component) {
    var _component$properties2;
    return (_component$properties2 = component.properties) === null || _component$properties2 === void 0 ? void 0 : _component$properties2.amountCents;
  }).filter(Boolean));
  if (uniqueAmounts.length !== 1) return undefined;
  if (!uniqueCurrencies[0] || !uniqueAmounts[0]) {
    return undefined;
  }
  var formattedAmount = new Intl.NumberFormat('default', {
    style: 'currency',
    currency: uniqueCurrencies[0],
    currencyDisplay: 'narrowSymbol'
  }).format(uniqueAmounts[0] / 100);
  return "".concat(formattedAmount, " ").concat(uniqueCurrencies[0]);
}
export function getAttachments(_ref5) {
  var _requirement$response2, _requirement$response3, _requirement$response4, _requirement$response5, _requirement$response8, _requirement$response9;
  var requirement = _ref5.requirement,
    questionKeys = _ref5.questionKeys;
  var attachmentIds = (_requirement$response2 = requirement.responses) !== null && _requirement$response2 !== void 0 && (_requirement$response3 = _requirement$response2.answersHistory) !== null && _requirement$response3 !== void 0 && _requirement$response3.length ? (_requirement$response4 = requirement.responses) === null || _requirement$response4 === void 0 ? void 0 : (_requirement$response5 = _requirement$response4.answersHistory[0].answers.find(function (answer) {
    return questionKeys.includes(answer.key);
  })) === null || _requirement$response5 === void 0 ? void 0 : _requirement$response5.value : undefined;
  if (!attachmentIds) {
    return undefined;
  }
  if (Array.isArray(attachmentIds)) {
    var _requirement$response6, _requirement$response7;
    return requirement === null || requirement === void 0 ? void 0 : (_requirement$response6 = requirement.responses) === null || _requirement$response6 === void 0 ? void 0 : (_requirement$response7 = _requirement$response6.attachments) === null || _requirement$response7 === void 0 ? void 0 : _requirement$response7.filter(function (attachment) {
      return attachmentIds.includes(attachment.id);
    });
  }
  return requirement === null || requirement === void 0 ? void 0 : (_requirement$response8 = requirement.responses) === null || _requirement$response8 === void 0 ? void 0 : (_requirement$response9 = _requirement$response8.attachments) === null || _requirement$response9 === void 0 ? void 0 : _requirement$response9.filter(function (attachment) {
    return attachmentIds === attachment.id;
  });
}
export function getAttachmentDecision(requirement, fileId) {
  var _requirement$response10, _requirement$response11, _requirement$response12, _requirement$response13;
  if (!((_requirement$response10 = requirement.responses) !== null && _requirement$response10 !== void 0 && (_requirement$response11 = _requirement$response10.answersHistory) !== null && _requirement$response11 !== void 0 && _requirement$response11.length) || !fileId) {
    return null;
  }
  var _iterator = _createForOfIteratorHelper((_requirement$response12 = (_requirement$response13 = requirement.responses) === null || _requirement$response13 === void 0 ? void 0 : _requirement$response13.answersHistory[0].answers) !== null && _requirement$response12 !== void 0 ? _requirement$response12 : []),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var answer = _step.value;
      var decision = answer.decisions.find(function (decision) {
        return 'item' in decision && decision.item === fileId;
      });
      if (decision) {
        return decision;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return null;
}
export function getAttachmentComponent(requirement, fileId) {
  var _requirement$response14, _requirement$response15, _requirement$response16;
  if (!((_requirement$response14 = requirement.responses) !== null && _requirement$response14 !== void 0 && (_requirement$response15 = _requirement$response14.answersHistory) !== null && _requirement$response15 !== void 0 && _requirement$response15.length)) return undefined;
  var attachmentAnswer = (_requirement$response16 = requirement.responses) === null || _requirement$response16 === void 0 ? void 0 : _requirement$response16.answersHistory[0].answers.find(function (answer) {
    return Array.isArray(answer.value) && answer.value.includes(fileId);
  });
  return requirement.formDefinition.components.find(function (component) {
    return component.key === (attachmentAnswer === null || attachmentAnswer === void 0 ? void 0 : attachmentAnswer.key);
  });
}

/**
 * Gets the attachments that are part of the user's current set of submitted
 * answers
 */
export var getLatestAttachments = function getLatestAttachments(requirement) {
  var _requirement$response17, _requirement$response18, _requirement$response19, _requirement$response20;
  var attachments = (_requirement$response17 = requirement === null || requirement === void 0 ? void 0 : (_requirement$response18 = requirement.responses) === null || _requirement$response18 === void 0 ? void 0 : _requirement$response18.attachments) !== null && _requirement$response17 !== void 0 ? _requirement$response17 : null;
  var answersHistory = (_requirement$response19 = requirement === null || requirement === void 0 ? void 0 : (_requirement$response20 = requirement.responses) === null || _requirement$response20 === void 0 ? void 0 : _requirement$response20.answersHistory) !== null && _requirement$response19 !== void 0 ? _requirement$response19 : null;
  if (!attachments || !answersHistory || answersHistory.length <= 0) {
    return [];
  }
  var attachmentComponents = requirement.formDefinition.components.filter(isPreviewableComponent);
  var attachmentAnswerIds = answersHistory[0].answers.filter(function (answer) {
    return attachmentComponents.find(function (component) {
      return component.key === answer.key;
    });
  }).flatMap(function (answer) {
    return Array.isArray(answer.value) ? answer.value : [];
  });
  var attachmentsForAnswer = attachments.filter(function (attachment) {
    return attachmentAnswerIds.includes(attachment.id);
  });
  return attachmentsForAnswer;
};